import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, appConfig)
  // Bootstrap failure is critical; logging kept for diagnostics (Sonar: S2228)
  .catch(err => console.error(err));
